import React from 'react';

const ExpertConsultation = () => {
  return (
    <div className="bg-gray-50 rounded-xl p-4 sm:p-6 shadow-inner w-full h-[22rem] w-full max-w-full overflow-x-auto flex-1">
      <div className="space-y-4 h-full flex flex-col justify-between">
        {/* Header */}
        <div className="text-center animate-fade-in-down">
          <h3 className="text-base font-semibold text-[#113262] mb-1">Expert Consultation</h3>
          <p className="text-xs text-[#8A8A8A]">Schedule a call with our investment experts</p>
        </div>

        {/* Features List - Single Line */}
        <div className="flex flex-row gap-4">
          <div className="flex items-center gap-2 animate-slide-in-left" style={{ animationDelay: '0.2s' }}>
            <div className="w-4 h-4 bg-[#1C52A0] rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
              ✓
            </div>
            <span className="text-xs font-medium text-[#113262]">Portfolio Analysis</span>
          </div>
          <div className="flex items-center gap-2 animate-slide-in-left" style={{ animationDelay: '0.4s' }}>
            <div className="w-4 h-4 bg-[#1C52A0] rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
              ✓
            </div>
            <span className="text-xs font-medium text-[#113262]">Risk Assessment</span>
          </div>
          <div className="flex items-center gap-2 animate-slide-in-left" style={{ animationDelay: '0.6s' }}>
            <div className="w-4 h-4 bg-[#1C52A0] rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
              ✓
            </div>
            <span className="text-xs font-medium text-[#113262]">Investment Strategies</span>
          </div>
        </div>

        {/* Stats Grid - Compact */}
        <div className="bg-[#E8EEF6] p-3 rounded-lg animate-fade-in-right" style={{ animationDelay: '0.8s' }}>
          <div className="grid grid-cols-2 gap-3 mb-3">
            <div className="text-center animate-bounce-in" style={{ animationDelay: '1s' }}>
              <div className="text-lg font-bold text-[#1C52A0] mb-0.5">15+</div>
              <div className="text-xs text-[#8A8A8A]">Years Exp.</div>
            </div>
            <div className="text-center animate-bounce-in" style={{ animationDelay: '1.2s' }}>
              <div className="text-lg font-bold text-[#1C52A0] mb-0.5">30</div>
              <div className="text-xs text-[#8A8A8A]">Min Call</div>
            </div>
            <div className="text-center animate-bounce-in" style={{ animationDelay: '1.4s' }}>
              <div className="text-lg font-bold text-[#22A06B] mb-0.5">Free</div>
              <div className="text-xs text-[#8A8A8A]">First Call</div>
            </div>
            <div className="text-center animate-bounce-in" style={{ animationDelay: '1.6s' }}>
              <div className="text-lg font-bold text-[#1C52A0] mb-0.5">98%</div>
              <div className="text-xs text-[#8A8A8A]">Satisfied</div>
            </div>
          </div>
          
          <button onClick={() => window.location.href = "/meeting"} className="w-full bg-gradient-to-r from-[#1C52A0] to-[#113262] text-white px-3 py-2 rounded-lg text-xs font-medium hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-in-up" style={{ animationDelay: '1.8s' }}>
            Schedule Call
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-down {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slide-in-left {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fade-in-right {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes bounce-in {
          0% {
            opacity: 0;
            transform: scale(0.3);
          }
          50% {
            opacity: 1;
            transform: scale(1.05);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-fade-in-down {
          animation: fade-in-down 0.8s ease-out both;
        }
        
        .animate-slide-in-left {
          animation: slide-in-left 0.6s ease-out both;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 1s ease-out both;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out both;
        }
        
        .animate-bounce-in {
          animation: bounce-in 0.8s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default ExpertConsultation;